import {
  type BoostTAEConfig,
  getBoostTAE,
  type IBoostTAE,
} from '@boost/widget-integration-tae/lib';
import { Global } from 'framework/core';

import { startSession } from '../../workers/workers-provider';

@Global()
export class AppService {
  get TAEApp(): IBoostTAE {
    return getBoostTAE();
  }

  get TAEAppConfig(): BoostTAEConfig {
    return this.TAEApp.config;
  }

  splitGoogleFontStyle(fontStyle: string) {
    if (!fontStyle) {
      return {
        fontWeight: 100,
        fontStyle: 'normal',
      };
    }
    if (fontStyle === 'regular') {
      return {
        fontWeight: 400,
        fontStyle: 'normal',
      };
    }
    const fontWeight = fontStyle.match(/\d+/);
    const fontStyleValue = fontStyle.replace(/\d+/g, '').trim();
    return {
      fontWeight: fontWeight ? fontWeight[0] : 100,
      fontStyle: fontStyleValue || 'normal',
    };
  }

  async templateRender<Data>(template: string, data: Data) {
    const translations = this.TAEAppConfig.translation || {};

    const { html } = await startSession('liquid-renderer').send({
      template,
      data: {
        ...data,
        translations,
      },
    });

    return html;
  }
}
